/**
 * StopButton - Emergency stop button for client view
 *
 * Features:
 * - Always visible in top-left corner
 * - High contrast for visibility
 * - Large touch target
 * - Emergency stop functionality
 */

interface StopButtonProps {
  onStop: () => void;
}

export function StopButton({ onStop }: StopButtonProps): JSX.Element {
  return (
    <button
      onClick={onStop}
      className="
        absolute top-4 left-4 z-50
        bg-red-600 hover:bg-red-700 active:bg-red-800
        text-white font-bold
        px-6 py-3 rounded-lg
        shadow-2xl hover:shadow-red-500/50
        transition-all duration-200
        flex items-center gap-2
        text-lg
      "
      aria-label="Stop bilateral stimulation"
    >
      <span className="text-xl">⏹</span>
      <span>STOP</span>
    </button>
  );
}
